import { resolveCustomerToolId, type CustomerToolKey } from "@ishvaram/domain-data/customer-tools";

type TrackProps = Record<string, unknown> | undefined;

function trackEventLazy(name: string, properties?: TrackProps) {
  if (typeof window === "undefined") return;
  void import("@/lib/analytics-events").then(({ trackEvent }) => trackEvent(name, properties));
}

export function trackCalculatorUsed(props: {
  calculator: CustomerToolKey;
  language?: string;
  [key: string]: unknown;
}) {
  const { calculator, ...properties } = props;
  const toolId = resolveCustomerToolId(calculator);
  const toolAlias = calculator === toolId ? undefined : calculator;
  trackEventLazy("calculator_used", {
    ...properties,
    calculator: toolId,
    ...(toolAlias ? { calculator_alias: toolAlias } : {}),
  });
  trackFreeToolCompleted({
    ...properties,
    tool_name: toolId,
    ...(toolAlias ? { tool_alias: toolAlias } : {}),
  });
}

export function trackMatchingCompleted(props: {
  attempt_id?: string;
  match_id?: string | null;
  score: number;
  language?: string;
  source_path?: string;
  input_mode?: "birth_details" | "naam_akshar";
}) {
  trackEventLazy("matching_completed", props);
}

export function trackFreeToolStarted(props: {
  tool_name: CustomerToolKey;
  source_path?: string;
  language?: string;
  placement?: string;
  step?: string;
  [key: string]: unknown;
}) {
  const { tool_name: toolName, ...properties } = props;
  const toolId = resolveCustomerToolId(toolName);
  const toolAlias = toolName === toolId ? undefined : toolName;
  trackEventLazy("free_tool_started", {
    ...properties,
    tool_name: toolId,
    ...(toolAlias ? { tool_alias: toolAlias } : {}),
  });
}

export function trackFreeToolCompleted(props: {
  tool_name: CustomerToolKey;
  source_path?: string;
  language?: string;
  placement?: string;
  step?: string;
  has_time?: boolean;
  [key: string]: unknown;
}) {
  const { tool_name: toolName, ...properties } = props;
  const toolId = resolveCustomerToolId(toolName);
  const toolAlias = toolName === toolId ? undefined : toolName;
  trackEventLazy("free_tool_completed", {
    ...properties,
    tool_name: toolId,
    ...(toolAlias ? { tool_alias: toolAlias } : {}),
  });
}
